import { TReduxActions } from '../../../common/actions';
import { EMarkAsViewedActionType } from '../../../common/actions/viewed';
import { EViewedCianIdsActionType } from '../../actions/viewedCianIds';

// Словарь, а не Set: redux-стейт сериализуется в SSR, а Set превратился бы в {}
export const defaultState: Record<number, true> = {};

export function viewedCianIdsReducer(
  state: Record<number, true> = defaultState,
  action: TReduxActions,
): Record<number, true> {
  switch (action.type) {
    case EMarkAsViewedActionType.Succeed: {
      const newCianIds = action.payload.cianIds.filter(cianId => !state[cianId]);

      if (!newCianIds.length) {
        return state;
      }

      const nextState = { ...state };
      newCianIds.forEach(cianId => {
        nextState[cianId] = true;
      });

      return nextState;
    }
    case EViewedCianIdsActionType.Reset:
      return defaultState;
    default:
      return state;
  }
}
